import {CLIENT_ERROR_CODES, CLIENT_ERROR_TYPES} from '../../constants';
import {BaseClientError} from './BaseClientError';

export class MongoIdError extends BaseClientError {
  constructor(type: CLIENT_ERROR_TYPES = CLIENT_ERROR_TYPES.MONGO_ID_BAD_FORMAT, data?: any) {
    super(CLIENT_ERROR_CODES.MONGO_ID, type, data);
  }
}
